import './login.scss';
import logo from "../../assets/logo.png";
import { Button, Space, Typography, Row, Col } from 'antd';
import authService from '../../configs/auth/authServices';

const { Title } = Typography;

const LoginPage = () => {
    return (
        <div className="limiter">
            <div className="container-login100">
                <div className="wrap-login100">
                    <Row gutter={{ lg: 24 }} className="mb15 ">
                        <Col className="gutter-row justify" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Space direction='horizontal' align='center' >
                                <div className="js-tilt" data-tilt>
                                    <img src={logo} alt="LOGO" width={"150"} />
                                </div>
                            </Space>
                        </Col>
                        <Col className="gutter-row justify" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Space direction='vertical' align='center' >
                                <Title level={3}>Benvenuto a CNA</Title>
                                <Button onClick={() => authService.login()} className='loginButton' size='large'>Accedi al portale</Button>
                            </Space>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}
export default LoginPage;